/**
 * Removes high-risk query parameter names from a path+query string before
 * sending as `page_path` in analytics (e.g. WooCommerce order `key`).
 * Matching is case-insensitive on parameter names only.
 */

const SENSITIVE_QUERY_PARAM_NAMES = new Set([
  "key", // WooCommerce order key
  "order_key",
  "token",
  "access_token",
  "refresh_token",
  "id_token",
  "password",
  "pwd",
]);

export function sanitizePagePathForAnalytics(fullPath: string): string {
  const qIndex = fullPath.indexOf("?");
  if (qIndex === -1) return fullPath;

  const pathname = fullPath.slice(0, qIndex);
  const queryString = fullPath.slice(qIndex + 1);
  if (!queryString) return fullPath;

  const params = new URLSearchParams(queryString);
  let removed = false;
  for (const name of [...params.keys()]) {
    if (SENSITIVE_QUERY_PARAM_NAMES.has(name.toLowerCase())) {
      params.delete(name);
      removed = true;
    }
  }
  if (!removed) return fullPath;

  const next = params.toString();
  return next ? `${pathname}?${next}` : pathname;
}
